import { $, $body, $doc, throttleScroll, bodyOverflow, debounceResize } from './_utility';

/*------------------------------------------------------------------

  Header

-------------------------------------------------------------------*/
function initHeader() {
  const $header = $('header.wp-block-template-part');
  const headerClassHide = 'harro-header-hide';
  const headerClassScroll = 'harro-header-scroll';

  if ($header.length) {
    $body.addClass('wp-block-header-existence');

    throttleScroll((type, scroll) => {
      if (!$header.hasClass('harro-header-visible')) {
        // Add class show or hide.
        if ('down' === type && 500 < scroll) {
          $header.addClass(headerClassHide);
          $body.addClass(headerClassHide);
        } else if ('up' === type || 'start' === type) {
          $header.removeClass(headerClassHide);
          $body.removeClass(headerClassHide);
        }
      }

      if (!$header.hasClass('harro-header-small')) {
        // Add scroll class.
        if (40 < scroll) {
          $header.addClass(headerClassScroll);
          $body.addClass(headerClassScroll);
        } else {
          $header.removeClass(headerClassScroll);
          $body.removeClass(headerClassScroll);
        }
      }
    });

    // Update variable height.
    let headerHeight = $header.outerHeight();

    debounceResize(() => {
      headerHeight = $header.outerHeight();

      if ($header.hasClass('harro-header-small')) {
        $body[0].style.setProperty('--wp-header-small--height', `${headerHeight}px`);
      } else {
        $body[0].style.setProperty('--wp-header--height', `${headerHeight}px`);
      }
    });
  }

  // Overflow body when show/hide navigation mobile.
  $doc.on('vpth-navigation-mobile-showing', () => {
    bodyOverflow(1);
  });

  $doc.on('vpth-navigation-mobile-hidden', () => {
    bodyOverflow(0);
  });
}

export { initHeader };
